import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { getAllCourseByInstructorActions } from "../slices";

function* getAllCourseByInstructorWorker({ payload }) {
  //   yield delay(300);
  try {
    yield put(getAllCourseByInstructorActions.pending());
    const response = yield call(courseAPI.getAllCourseByInstructor, payload);
    yield put(getAllCourseByInstructorActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllCourseByInstructorActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getAllCourseByInstructorWorker };
